import { apiClient } from "../api/apiclient"

export const resetPassword = (resetPasswordRequest, token) =>
    apiClient.patch("/reset-password", resetPasswordRequest,{
        headers: { Authorization: `Bearer ${token}` },
    });